import angular from 'angular';
import uiRouter from 'angular-ui-router';
import procedureTemplatesComponent from './procedure-templates.component';
import dataTable from 'angular-material-data-table';

let procedureTemplatesModule = angular.module('procedureTemplates', [
    uiRouter,
    dataTable
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('procedureTemplates', {
        url: '/procedureTemplates',
        component: 'procedureTemplates',
        parent: 'main',
        data: {
            permissions: {
                only: ['OPERATOR'],
                redirectTo: 'home'
            }
        },
        resolve: {
        }
    });
})
.component('procedureTemplates', procedureTemplatesComponent)
.name;

export default procedureTemplatesModule;
